import { formatDate } from '@common/paymentsUtils/dateUtils';
import { Alert, Box, Paragraph, Text } from '@zillow/constellation-10';
import type { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import TotalPaymentModule from '@renter-hub/components/TotalPaymentModule';
import { SelectedPaymentMethod } from '@renter-hub/components/SelectedPaymentMethod';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface Props {
  dueAmount: number;
  fee?: number;
  paymentMethod?: RenterPaymentMethodInterface;
  selectedDate: string;
  totalAmount?: number;
}

const OneTimeConfirmationPage = (props: Props) => {
  const { selectedDate, dueAmount, totalAmount, paymentMethod, fee } = props;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.sm)' }}>
      <Box>
        <Paragraph textStyle="body-bold">Send date</Paragraph>
        <Text>{formatDate(selectedDate, 'MMM d, yyyy')}</Text>
      </Box>
      {paymentMethod && (
        <SelectedPaymentMethod
          displayName={paymentMethod.displayName}
          nickname={paymentMethod.nickname}
          accountLast4={paymentMethod.accountLast4}
        />
      )}
      <Box>
        {totalAmount ? (
          <TotalPaymentModule feeAmount={fee} totalAmount={totalAmount} heading="Rent amount" />
        ) : (
          <>
            <Paragraph textStyle="body-bold">Total amount</Paragraph>
            <Text>{centsToDollars(dueAmount)}</Text>
          </>
        )}
      </Box>
      <Alert tone="info">We’ll email you a reminder five days before your payment is due each month</Alert>
    </Box>
  );
};

export default OneTimeConfirmationPage;
